import React, {Dispatch, PropsWithChildren, SetStateAction, useContext} from 'react';
import {KeysArray} from '../../../../models/Constants/RequiredFields';
import {TEntity} from '../../../../models/entity';
import {ErrorObject} from '../../../utils/formUtils';
import {EditorModus} from '../EditDialog/EditDialog';
import {ConfirmActionState} from '../ConfirmDialog/ConfirmDialog';

interface EditPanelContext<T extends TEntity> {
    setConfirmActionState?: React.Dispatch<React.SetStateAction<ConfirmActionState | undefined>>;
    setValue: Dispatch<SetStateAction<T | undefined>>;
    setValid: Dispatch<SetStateAction<boolean>>;
    setPristine: Dispatch<SetStateAction<boolean>>;
    setErrors: Dispatch<SetStateAction<ErrorObject>>;
    setHeaderButtons?: Dispatch<SetStateAction<JSX.Element | null | undefined>>;
    errors: ErrorObject;
    validateField: (fieldValue: any, key: string, setValidation?: boolean, informUser?: boolean, extraErrors?: ErrorObject | undefined) => void;
    validate: (fieldValues: T, errorPropertyNames?: KeysArray<T>, extraErrors?: ErrorObject) => boolean;
    handleFieldValidation: (fieldName: string, isValid: boolean, errorMessage?: string | undefined) => void;
    mode: EditorModus;
}

const editPanelContext = React.createContext({} as EditPanelContext<any>);

export function useEditPanelContext<T extends TEntity>() {
    return useContext<EditPanelContext<T>>(editPanelContext);
}

export function EditPanelProvider<T extends TEntity>({
                                                         children,
                                                         ...providerValue
                                                     }: PropsWithChildren<EditPanelContext<T>>) {
    const {Provider} = editPanelContext as React.Context<EditPanelContext<T>>;

    return <Provider value={providerValue}>{children}</Provider>;
}


export default React.memo(EditPanelProvider) as typeof EditPanelProvider;
